import React from 'react'

const TabItem = ({selected, text, className, onClick, count}) => {
  return (
    <div
      className={`cursor-pointer border-primary ${className} ${selected === text ? 'border-b-4' : 'opacity-50'}`}
      onClick={() => onClick(text)}
    >
      <div className="flex items-center text-sm lg:text-base uppercase">
        <p className="mr-1 font-bold font-accent">
          {text}
        </p>
        <p className="font-accent font-normal">
          ({count})
        </p>
      </div>
    </div>
  )
}

const ListNav = ({selected, onChange, mobile}) => {
  return (
    <div className="flex overflow-x-auto border-b mb-5 lg:mb-8">
      <TabItem
        selected={selected}
        onClick={onChange}
        text="Program"
        count={11}
        className={mobile ? `p-3 text-center` : `pb-4 mr-12`}
      />
      <TabItem
        selected={selected}
        onClick={onChange}
        text="Organization"
        count={4}
        className={mobile ? `p-3 text-center` : `pb-4 mr-12`}
      />
      <TabItem
        selected={selected}
        onClick={onChange}
        text="Event"
        count={4}
        className={mobile ? `p-3 text-center` : `pb-4 mr-12`}
      />
      <TabItem
        selected={selected}
        onClick={onChange}
        text="Resources"
        count={0}
        className={mobile ? `p-3 text-center` : `pb-4 mr-12`}
      />
      <TabItem
        selected={selected}
        onClick={onChange}
        text="Blog"
        count={2}
        className={mobile ? `p-3 text-center` : `pb-4`}
      />
    </div>
  )
}

export { ListNav }